export default "__VITE_PUBLIC_ASSET__ebb26cd1__"